import { GA_Push } from "./GoogleAnalytics";
import { mobile } from "./Agent";

var urlToShare = window.location.href;
var faceUrlToShare = `https://z.ynet.co.il//mshort/generics/Leads/OsemLead/?utm_source=${mobile() ? "m.ynet.co.il":"ynet.co.il"}&utm_medium=social&utm_campaign=facebook&utm_term=Osem`
var textToShare = "יש לכם מתכון מאוזן מנצח? יש לכם שדרוג בריא למתכון ממש טעים שגם קל להכין? במסגרת הפרויקט: חיים מאוזנים – חיים טובים המשותף לידיעות אחרונות, ynet, אסם ונסטלה, אנחנו מזמינים אתכם לספר לנו על המתכון המשפחתי שלכם לארוחה מאוזנת >> " + window.location.href;

const shareFacebook = () => {
  GA_Push("Share_Events", "Share Facebook", "Osem Lead" , "Social - Share");
  window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(faceUrlToShare), "_blank");
};

const shareTwitter = () => {
  GA_Push("Share_Events", "Share Twitter", "Osem Lead" , "Social - Share");
  window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(textToShare), "_blank");
};

const shareWhatsapp = () => {
  GA_Push("Share_Events", "Share WhatsApp", "Osem Lead" , "Social - Share");
  if (mobile()) {
    window.open("whatsapp://send?text=" + encodeURIComponent(textToShare), "_parent");
  } else {
    window.open("https://web.whatsapp.com/send?phone=&text=" + encodeURIComponent(textToShare), "_blank");
  }
};

const openNegishut = () => {
  window.document.getElementById("INDmenu-btn").click();
  GA_Push("Accessibility", "Open_Accessibility_Clicked");
};

export { shareFacebook, shareTwitter, shareWhatsapp, openNegishut };



// WEBPACK FOOTER //
// ./src/Components/Services/Sharing.js